import React, { useEffect, useState, useMemo } from "react";
import { Row, Input, FormGroup, Label, Form } from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import "react-datepicker/dist/react-datepicker.css";
import countryList from "react-select-country-list";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CurrencyFormat from "react-currency-format";
import GooglePlacesComponent from "../../../../candidateinfo/GooglePlacesComponent";
import { showSalary } from "../../../../../utilities/showsalary";
import { useHistory } from "react-router-dom";
import Geocode from "react-geocode";
import { ENV } from "../../../../../config/ENV";
import { ProfileService } from "../../../../../services/ProfileService";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";

Geocode.setApiKey(ENV.google_api_key);

const JobPreferences = () => {
  
  const history = useHistory();
  const countries = useMemo(() => countryList().getData(), []);
  const [country, setCountry] = useState("");
  const [radius, setRadius] = useState("");
  const [jobStatus, setJobStatus] = useState("");
  const [salType, setSalType] = useState("");
  const [jobType, setJobType] = useState("");
  const [availability, setAvailability] = useState("Immediate");
  const [term, setTerm] = useState("");
  const [jobShift, setJobShift] = useState("");
  const [workFromHome, setWorkFromHome] = useState(false);
  const [relocateAnywhere, setrelocateAnywhere] = useState(false);
  const [health, setHealth] = useState(false);
  const [dental, setDental] = useState(false);
  const [vision, setVision] = useState(false);
  const [paidHolidays, setPaidHolidays] = useState(false);
  const [paidSickTime, setPaidSickTime] = useState(false);
  const [paidVacation, setPaidVacation] = useState(false);
  const [selectdCounty, setSelectedCountry] = useState("");
  const [jobPrefTypes, setJobPrefTypes] = useState([]);
  const [salTypes, setSalTypes] = useState([]);
  const [jobTerms, setJobTerms] = useState([]);
  const [jobShifts, setJobShifts] = useState([]);
  const [salaryMin, setSalaryMin] = useState("");
  const [salaryMax, setSalaryMax] = useState("");
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);
  const [jobPrefStatusOptions, setJobPrefStatusOptions] = useState([]);
  const [workModel, setWorkModel] = useState("ANY");
  const [workModelTypeOptions, setWorkModelTypeOptions] = useState([]);
  const [inputAddressField, setInputAddressField] = useState({
    line1: "",
    line2: "",
    street: "",
    area: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    latitude: "",
    longitude: "",
  });

  const [inputField, setInputField] = useState({
    contactNumber: "",
    workRadius: "",
    zipCode: "",
    minSal: "",
    maxSal: "",
    additionalInfo: "",
  });

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCallback = (googlePlaces) => {
    setInputAddressField((prevState) => ({
      ...prevState,
      street: googlePlaces.street,
      area: googlePlaces.area,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      country: googlePlaces.country,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));
    countries.map((country) => {
      if (country.label == googlePlaces.country) {
        setCountry(country);
        setSelectedCountry(googlePlaces.country);
      }
    });
  };

  const handleJobStatusSelectChange = (e) => {
    setJobStatus(e.target.value);
  };

  const handleWorkModelChange = (e) => {
    setWorkModel(e.target.value);
  };

  const handleRadiusSelectChange = (e) => {
    if (e.target.value == "-1") {
      setWorkFromHome(false);
      setrelocateAnywhere(true);
      setRadius(e.target.value);
    } else if (e.target.value == "-2") {
      setWorkFromHome(true);
      setrelocateAnywhere(false);
      setRadius(e.target.value);
    } else {
      setWorkFromHome(false);
      setrelocateAnywhere(false);
      setRadius(e.target.value);
    }
  };

  const handleSalTyepSelectChange = (e) => {
    setSalType(e.target.value);
  };

  const handleJobTyepSelectChange = (e) => {
    setJobType(e.target.value);
  };

  const handleAvailabilitySelectChange = (e) => {
    setAvailability(e.target.value);
  };

  const handleJobShiftSelectChange = (e) => {
    setJobShift(e.target.value);
  };

  const handleTermSelectChange = (e) => {
    setTerm(e.target.value);
  };

  let count = 0;
  useEffect(() => {
    if (
      !Stringutility.isNullOrEmpty(window.localStorage.getItem("enumsLists"))
    ) {
      var enumsLists = JSON.parse(window.localStorage.getItem("enumsLists"));
      if (enumsLists.jobPrefStatues != null) {
        setJobPrefStatusOptions(enumsLists.jobPrefStatues);
      }

      if (enumsLists.jobPrefTypes != null) {
        setJobPrefTypes(enumsLists.jobPrefTypes);
      }
      if (enumsLists.candidateWorkModelTypes != null) {
        setWorkModelTypeOptions(enumsLists.candidateWorkModelTypes);
      }

      if (enumsLists.jobSalaryTypes != null) {
        setSalTypes(enumsLists.jobSalaryTypes);
      }

      if (enumsLists.jobTerms != null) {
        setJobTerms(enumsLists.jobTerms);
      }

      if (enumsLists.jobShifts != null) {
        setJobShifts(enumsLists.jobShifts);
      }
    }
    getPreferenceDetails();
  }, [count]);

  const printAddresss = (addressObj) => {
    if (!Stringutility.isNullOrEmpty(addressObj)) {
      var add = [];
      let street = Stringutility.getValue(addressObj.street);
      if (street != "") {
        add.push(street);
      }
      let area = Stringutility.getValue(addressObj.area);
      if (area != "") {
        add.push(area);
      }
      let city = Stringutility.getValue(addressObj.city);
      if (city != "") {
        add.push(city);
      }
      let state = Stringutility.getValue(addressObj.state);
      if (state != "") {
        add.push(state);
      }
      // if (!isNullOrEmpty(addressObj.country)){
      //   add.push(addressObj.country)
      // }
      let zipcode = Stringutility.getValue(addressObj.zipcode);
      if (zipcode != "") {
        add.push(zipcode);
      }
    }
    return add.join(", ");
  };

  const getPreferenceDetails = () => {
    ProfileService.getPreferences().then((response) => {
      try {
        var preferenceDetails = response.data;
        if (preferenceDetails != null) {
          if (!Stringutility.isNullOrEmpty(preferenceDetails.jobStatus)) {
            setJobStatus(preferenceDetails.jobStatus.key);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.workRadius)) {
            setRadius(preferenceDetails.workRadius);
          }

          let salaryMin = preferenceDetails.salaryMin;
          if (!Stringutility.isNullOrEmpty(salaryMin)) {
            if (salaryMin !== 0) {
              setSalaryMin(salaryMin);
            }
          }

          let salaryMax = preferenceDetails.salaryMax;
          if (!Stringutility.isNullOrEmpty(salaryMax)) {
            if (salaryMax !== 0) {
              setSalaryMax(salaryMax);
            }
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.salaryType)) {
            setSalType(preferenceDetails.salaryType.key);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.jobType)) {
            setJobType(preferenceDetails.jobType.key);
          }
          if (!Stringutility.isNullOrEmpty(preferenceDetails.workModelType)) {
            setWorkModel(preferenceDetails.workModelType.key);
          }

          let address = preferenceDetails.address;
          if (address != null || address != "") {
            let street = Stringutility.getValue(address.street);
            let area = Stringutility.getValue(address.area);
            let city = Stringutility.getValue(address.city);
            let state = Stringutility.getValue(address.state);
            let country = Stringutility.getValue(address.country);
            let zipcode = Stringutility.getValue(address.zipcode);
            let latitude = Stringutility.getValue(address.latitude);
            let longitude = Stringutility.getValue(address.longitude);

            setInputAddressField((prevState) => ({
              ...prevState,
              line1: street,
              area: area,
              city: city,
              state: state,
              country: country,
              zipcode: zipcode,
              latitude: latitude,
              longitude: longitude,
            }));

            if (country != "") {
              countries.map((countryObj) => {
                if (countryObj.label == country) {
                  setCountry(countryObj);
                  setSelectedCountry(country);
                }
              });
            }
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.availability)) {
            setAvailability(preferenceDetails.availability);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.empTerm)) {
            setTerm(preferenceDetails.empTerm.key);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.shifts)) {
            setJobShift(preferenceDetails.shifts.key);
          }
          if (!Stringutility.isNullOrEmpty(preferenceDetails.additionalInfo)) {
            setInputField((prevState) => ({
              ...prevState,
              additionalInfo: preferenceDetails.additionalInfo,
            }));
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.health)) {
            setHealth(preferenceDetails.health);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.dental)) {
            setDental(preferenceDetails.dental);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.vision)) {
            setVision(preferenceDetails.vision);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.paidHolidays)) {
            setPaidHolidays(preferenceDetails.paidHolidays);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.paidSickTime)) {
            setPaidSickTime(preferenceDetails.paidSickTime);
          }

          if (!Stringutility.isNullOrEmpty(preferenceDetails.paidVacation)) {
            setPaidVacation(preferenceDetails.paidVacation);
          }
        }
      } catch (err) {
        console.error("getPreferences" + JSON.stringify(err));
      }
    });
  };

  const salaryMinHandler = (e) => {
    const value = e.target.value;
    const number = value.replace(/\$|,|/g, "");

    if (number != "") {
      setSalaryMin(number);
    } else {
      setSalaryMin(e.target.value);
    }
  };

  const salaryMaxHandler = (e) => {
    const value = e.target.value;
    const number = value.replace(/\$|,|/g, "");
    if (number != "") {
      setSalaryMax(number);
    } else {
      setSalaryMax(e.target.value);
    }
  };

  const handleCancelButton=()=>{
    history.push("/smartresume");
  }

  const submitButton = () => {
    if (salaryMin == 0) {
      Stringutility.showErrorMessage(Constants.enterDesiredSalary);
      return;
    }
    if (salaryMax == 0) {
      Stringutility.showErrorMessage(Constants.enterDesiredSalary);
      return;
    }

    if (salaryMin != 0 && salaryMax == 0) {
      Stringutility.showErrorMessage(Constants.enterMaximumSalary);
      return;
    }

    if (salaryMin != 0 && salaryMax != 0) {
      const minium = parseInt(salaryMin);
      const maximum = parseInt(salaryMax);

      if (minium > maximum) {
        Stringutility.showErrorMessage(Constants.maxSalMustbeGreaterThanMinSal);
        return;
      }
    }

    if (inputAddressField.latitude == "" && inputAddressField.latitude == 0) {
      const fullAddress =
        inputAddressField.street +
        "," +
        inputAddressField.area +
        "," +
        inputAddressField.city +
        "," +
        inputAddressField.state +
        "," +
        inputAddressField.zipcode +
        "," +
        selectdCounty;
      Geocode.fromAddress(fullAddress).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          if (Stringutility.isNullOrEmpty(lat)) {
            Stringutility.showErrorMessage(Constants.selectPreciseAddress);
            return;
          }

          if (Stringutility.isNullOrEmpty(lng)) {
            Stringutility.showErrorMessage(Constants.selectPreciseAddress);
            return;
          }
        },
        (error) => {
          console.error(error);
          Stringutility.showErrorMessage(Constants.selectPreciseAddress);
          return;
        }
      );
      return;
    }

    if (radius == "") {
      Stringutility.showErrorMessage(Constants.selectWorkRadius);
      return;
    }

    if (salType == "") {
      Stringutility.showErrorMessage(Constants.selectSalaryType);
      return;
    }

    if (term == "") {
      Stringutility.showErrorMessage(Constants.selectEmploymentTerm);
      return;
    }

    if (jobShift == "") {
      Stringutility.showErrorMessage(Constants.selectJobShift);
      return;
    }

    if (inputAddressField.latitude !== "" && inputAddressField.latitude !== 0) {
      addJobPreferences(
        inputAddressField.latitude,
        inputAddressField.longitude
      );
    } else {
      const fullAddress =
        inputAddressField.street +
        "," +
        inputAddressField.area +
        "," +
        inputAddressField.city +
        "," +
        inputAddressField.state +
        "," +
        inputAddressField.zipcode +
        "," +
        selectdCounty;
      Geocode.fromAddress(fullAddress).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          if (Stringutility.isNullOrEmpty(lat)) {
            Stringutility.showErrorMessage(Constants.selectPreciseAddress);
            return;
          }

          if (Stringutility.isNullOrEmpty(lng)) {
            Stringutility.showErrorMessage(Constants.selectPreciseAddress);
            return;
          }

          addJobPreferences(lat, lng);
        },
        (error) => {
          console.error(error);
          Stringutility.showErrorMessage(Constants.selectPreciseAddress);
        }
      );
    }
    // history.push("/smartresume");
  };

  const addJobPreferences = (latitude, longitude) => {
    const moAddress = {
      street: inputAddressField.line1,
      area: inputAddressField.area,
      city: inputAddressField.city,
      state: inputAddressField.state,
      country: selectdCounty,
      zipcode: inputAddressField.zipcode,
      latitude: latitude,
      longitude: longitude,
    };

    const preferenceReqReqest = {
      jobStatus: jobStatus,
      workRadius: radius,
      salaryMin: salaryMin,
      salaryMax: salaryMax,
      salaryType: salType,
      workModelType: workModel,
      workFromHome: workFromHome,
      relocateAnywhere: relocateAnywhere,
      jobType: jobType,
      availability: availability,
      empTerm: term,
      shifts: jobShift,
      additionalInfo: inputField.additionalInfo,
      address: moAddress,
      health: health,
      dental: dental,
      vision: vision,
      paidHolidays: paidHolidays,
      paidSickTime: paidSickTime,
      paidVacation: paidVacation,
    };

    setSaveBtnEnabled(true);
    ProfileService.addPreferences(preferenceReqReqest).then((response) => {
      setSaveBtnEnabled(false);
      try {
        // toast.success("Preference details updated successfully");
      } catch (err) {
        console.error("addPreferences" + JSON.stringify(err));
      }
    });
  };
  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">
<div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <div className="addexperience right">
              <div className="profile-card-title">
                  <h2 className="t-h2-font-sm">
                    <strong>Job Preferences</strong>
                  </h2>
                <div className="horizontal_line" />
              </div>

              <Form className="mt-4">
                <FormGroup row>
                  <Label md={3}>Status</Label>
                  <Colxx md={4}>
                    <Input
                      className="t-rounded-lg"
                      value={jobStatus}
                      type="select"
                      onChange={handleJobStatusSelectChange}
                    >
                      {jobPrefStatusOptions.length > 0 &&
                        jobPrefStatusOptions.map(({ value, key }) => (
                          <option value={key} key={key}>
                            {value}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                </FormGroup>

                <FormGroup row>
                  <Label md={3}>Job Type*</Label>
                  <Colxx md={4}>
                    <Input
                      className="t-rounded-lg"
                      value={jobType}
                      type="select"
                      onChange={handleJobTyepSelectChange}
                    >
                      {jobPrefTypes.length > 0 &&
                        jobPrefTypes.map(({ value, key }) => (
                          <option value={key} key={key}>
                            {value}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Desired Salary*</Label>
                  <Colxx md={2}>
                    <CurrencyFormat
                      className="t-rounded-lg "
                      customInput={Input}
                      placeholder="Minimum Salary"
                      onChange={salaryMinHandler}
                      value={showSalary(salaryMin, salaryMin, salaryMax)}
                      decimalScale={2}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </Colxx>
                  <span className="t-hidden-col">
                    {" "}
                    <strong>-</strong>
                  </span>
                  <Colxx md={2}>
                    <CurrencyFormat
                      className="t-rounded-lg t-sal-margin-top"
                      customInput={Input}
                      placeholder="Maximum Salary"
                      onChange={salaryMaxHandler}
                      value={showSalary(salaryMax, salaryMin, salaryMax)}
                      decimalScale={2}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </Colxx>

                  <Colxx md={2}>
                    <Input
                      className="t-rounded-lg t-sal-margin-top"
                      value={salType}
                      type="select"
                      onChange={handleSalTyepSelectChange}
                    >
                      <option value="">Please Select</option>
                      {salTypes.length > 0 &&
                        salTypes.map(({ value, key }) => (
                          <option value={key} key={key}>
                            {capitalizeFirst(value)}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                </FormGroup>

                <hr />
                <FormGroup>
                  <Label className="card-title-experience t-display-pre">
                    <strong>
                      Preferred work location (Be as specific as possible)
                    </strong>
                  </Label>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Location Center*</Label>
                  <div className="col-md-6">
                    <GooglePlacesComponent parentCallback={handleCallback} />
                    <div className="row ml-2">
                      <Colxx md={12}>
                        <Row>{printAddresss(inputAddressField)}</Row>
                      </Colxx>
                    </div>
                  </div>
                </FormGroup>

                <FormGroup row>
                  <Label md={3}>Radius from Center*</Label>
                  <Colxx md={6}>
                    <Input
                      className="t-rounded-lg"
                      value={radius}
                      type="select"
                      onChange={handleRadiusSelectChange}
                    >
                      <option value="">Please Select</option>
                      <option value="1">Up to 1 mile </option>
                      <option value="2">Up to 2 miles</option>
                      <option value="5">Up to 5 miles</option>
                      <option value="10">Up to 10 miles</option>
                      <option value="20">Up to 20 miles</option>
                      <option value="25">Up to 25 miles</option>
                      <option value="30">Up to 30 miles</option>
                      <option value="40">Up to 40 miles</option>
                      <option value="50">Up to 50 miles</option>
                      <option value="75">Up to 75 miles</option>
                      <option value="100">Up to 100 miles</option>
                      <option value="-1">
                        Will relocate anywhere in the US
                      </option>
                      <option value="-2">Work from home only</option>
                    </Input>
                    <div className="row ml-2 mt-3">
                      <Colxx sm={12}>
                        <Row>
                          {radius > 0 ? (
                            <>
                              {radius == 1 ? (
                                <>
                                  Up to {radius} mile from{" "}
                                  {printAddresss(inputAddressField)}
                                </>
                              ) : (
                                <>
                                  Up to {radius} miles from{" "}
                                  {printAddresss(inputAddressField)}
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )}{" "}
                        </Row>
                      </Colxx>
                    </div>
                  </Colxx>
                </FormGroup>
                <FormGroup row>
                  <Label md={3}>Work Model*</Label>
                  <Colxx md={6}>
                    <Input
                      className="t-rounded-lg"
                      value={workModel}
                      type="select"
                      onChange={handleWorkModelChange}
                    >
                      {workModelTypeOptions.length > 0 &&
                        workModelTypeOptions.map(({ value, key }) => (
                          <option value={key} key={key}>
                            {value}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                </FormGroup>

                <div className="horizontal_line" />

                <div>
                  <Label className="profile-card-subtitle mt-2">
                    <strong>Required Benefits</strong>
                  </Label>
                </div>

                <div>
                  <Label className="profile-card-subtitle mt-2">
                    Insurance
                  </Label>
                </div>

                <Colxx sm={12}>
                  <div className="row form-group">
                    <div className="col-sm-4">
                      <div className="custom-checkbox custom-control custom-control-inline">
                        <input
                          checked={health}
                          onChange={(e) => setHealth(e.target.checked)}
                          type="checkbox"
                          data-testid="jobpreferences-health"
                          id="health"
                          className="custom-control-input"
                        />
                        <label
                          className="custom-control-label row-sm-4"
                          htmlFor="health"
                        >
                          Health
                        </label>
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="custom-checkbox custom-control custom-control-inline">
                        <input
                          checked={dental}
                          onChange={(e) => setDental(e.target.checked)}
                          type="checkbox"
                          data-testid="jobpreferences-dental"
                          id="dental"
                          className="custom-control-input"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="dental"
                        >
                          Dental
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="custom-checkbox custom-control custom-control-inline">
                        <input
                          checked={vision}
                          onChange={(e) => setVision(e.target.checked)}
                          type="checkbox"
                          id="vision"
                          data-testid="jobpreferences-vision"
                          className="custom-control-input"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="vision"
                        >
                          Vision
                        </label>
                      </div>
                    </div>
                  </div>
                </Colxx>

                <div>
                  <Label className="profile-card-subtitle mt-2">
                    Paid Time Off
                  </Label>
                </div>

                <Colxx sm={12}>
                  <div className="row form-group">
                    <div className="col-sm-4">
                      <div className="custom-checkbox custom-control custom-control-inline">
                        <input
                          checked={paidHolidays}
                          onChange={(e) => setPaidHolidays(e.target.checked)}
                          type="checkbox"
                          data-testid="jobpreferences-paidHolidays"
                          id="paidHolidays"
                          className="custom-control-input"
                        />
                        <label
                          className="custom-control-label row-sm-4"
                          htmlFor="paidHolidays"
                        >
                          Paid Holidays
                        </label>
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="custom-checkbox custom-control custom-control-inline">
                        <input
                          checked={paidSickTime}
                          onChange={(e) => setPaidSickTime(e.target.checked)}
                          type="checkbox"
                          id="paidSickTime"
                          data-testid="jobpreferences-paidSickTime"
                          className="custom-control-input"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="paidSickTime"
                        >
                          Paid Sick Time
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="custom-checkbox custom-control custom-control-inline">
                        <input
                          checked={paidVacation}
                          onChange={(e) => setPaidVacation(e.target.checked)}
                          type="checkbox"
                          id="paidVacation"
                          data-testid="jobpreferences-paidVacation"
                          className="custom-control-input"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="paidVacation"
                        >
                          Paid Vacation
                        </label>
                      </div>
                    </div>
                  </div>
                </Colxx>

                <div className="horizontal_line" />
                <Label className="profile-card-subtitle mt-3">
                  <strong>Additional Job Preferences</strong>
                </Label>

                <FormGroup row>
                  <Label md={3}>Availability</Label>
                  <Colxx md={4}>
                    <Input
                      className="t-rounded-lg"
                      value={availability}
                      type="select"
                      onChange={handleAvailabilitySelectChange}
                    >
                      <option value="Immediate">Immediate</option>
                      <option value="1 week">1 week</option>
                      <option value="2 weeks">2 weeks</option>
                      <option value="3 weeks">3 weeks</option>
                      <option value="4 weeks">4 weeks</option>
                      <option value="5 weeks">5 weeks</option>
                      <option value="6 weeks">6 weeks</option>
                      <option value="7 weeks">7 weeks</option>
                      <option value="8 weeks">8 weeks</option>
                    </Input>
                  </Colxx>
                </FormGroup>

                <FormGroup row>
                  <Label md={3}>Employment Term*</Label>
                  <Colxx md={4}>
                    <Input
                      className="t-rounded-lg"
                      value={term}
                      type="select"
                      onChange={handleTermSelectChange}
                    >
                      <option value="">Please Select</option>
                      {jobTerms.length > 0 &&
                        jobTerms.map(({ value, key }) => (
                          <option value={key} key={key}>
                            {value}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                </FormGroup>

                <FormGroup row>
                  <Label md={3}>Job Shifts*</Label>
                  <Colxx md={4}>
                    <Input
                      className="t-rounded-lg"
                      value={jobShift}
                      type="select"
                      onChange={handleJobShiftSelectChange}
                    >
                      <option value="">Please Select</option>
                      {jobShifts.length > 0 &&
                        jobShifts.map(({ value, key }) => (
                          <option value={key} key={key}>
                            {value}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                </FormGroup>

                <FormGroup row>
                  <Label md={3}>Additional Info</Label>
                  <Colxx md={8}>
                    <Input
                      className="t-rounded-lg"
                      rows="4"
                      data-testid="jobpreferences-additionalInfo"
                      type="textarea"
                      name="additionalInfo"
                      onChange={inputsHandler}
                      value={inputField.additionalInfo}
                    />
                  </Colxx>
                </FormGroup>
              </Form>
              <div className="mt-5">
                <TeamanicsButton
                  onClick={handleCancelButton}
                  >
                    Cancel
                  </TeamanicsButton>
                  <TeamanicsButton
                  className="ml-2"
                  onClick={submitButton}
                  disabled={saveBtnEnabled}
                >
                  Save
                </TeamanicsButton>
              </div>
            </div>
            <div className="mb-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobPreferences;
